import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/CommonService/data.service';
import { AppTokenHandler } from 'src/app/CommonService/app-token-handler';
import { CommonService } from 'src/app/Shared/common.service';

@Component({
  selector: 'app-privacy-notice',
  templateUrl: './privacy-notice.component.html',
  styleUrls: ['./privacy-notice.component.css']
})
export class PrivacyNoticeComponent implements OnInit {
  IsConsentAgreed: boolean = false;
  userRecord = new UserRecord();
  UserName!: string;
  UserRole!: string;
  EmpGPN!:string;
  IsLoadingResults: boolean = false;

  constructor(private dbService: DataService,
              private router: Router,
              private _dataservice: CommonService,
              private appToken: AppTokenHandler) { }

  ngOnInit(): void {
    const UserDetails = this.appToken.getLoginUserInfo();
    if (UserDetails != null) {
      this.UserName = UserDetails.EmpName;
      this.UserRole = UserDetails.Roles;
      this.EmpGPN = UserDetails.EmpGPN;
    }
  }

  ConfirmPrivacyNotice() {
    try{
      this.IsLoadingResults = true;
      let currentDate = new Date();
      this.userRecord.EmpGPN = this.EmpGPN;
      this.userRecord.IsConsentAgreed = true;
      this.userRecord.AgreedOn = currentDate;
      this._dataservice.PostService(this.userRecord,'PrivacyNotice/SubmitPrivacyConsent').subscribe(
          () => {
              this.router.navigate(['/home']);
              this.IsLoadingResults = false;
          });
    }
    catch (Exception)
    {
      console.log(Exception);
      this.IsLoadingResults = false;
    }

}

}

export class UserRecord {
  EmpGPN!: string;
  IsConsentAgreed!: boolean;
  AgreedOn!: Date;
}